import axios from 'axios';

// Calls of the convention page. The page holds no token: every call goes to the whitelisted BFF of the
// front-hia server (`/ack-api/...`, server/whitelist.js), which adds a server-side token before calling back-hia.
// Nothing here logs a response, an answer, a practice id, a marker or the ack token.
export const ACK_API = '/ack-api/conventions';

const token = (ackToken) => encodeURIComponent(ackToken);

// A failed call, normalised to { status, key }. back-hia business errors carry `errors[0].key`
// (e.g. `ack.key.session.expired`); the practice relay answers `{ status, error: <reason> }`; a BFF 404 / 502
// has no business key.
export const normalizeError = (error) => {
    const response = error && error.response;
    const status = response && typeof response.status === 'number' ? response.status : null;
    const data = (response && response.data) || {};
    const first = Array.isArray(data.errors) && data.errors[0] ? data.errors[0] : null;
    const raw = (first && (first.key || first.code)) || data.key || data.error || data.message || null;
    return { status, key: typeof raw === 'string' ? raw : null };
};

const call = (request) => request.catch((error) => Promise.reject(normalizeError(error)));

// POST ack-start: consumes one opening of the link. `serverDate` is the `Date` header of the response,
// used as "server now" to compute the remaining session time without trusting the device clock.
export const startAck = (ackToken, language) =>
    call(axios.post(`${ACK_API}/${language}/ack-start?ackToken=${token(ackToken)}`, null)).then((response) => ({
        data: response.data,
        serverDate: (response.headers && (response.headers.date || response.headers.Date)) || null,
    }));

export const getPractice = (ackToken, language, mode) =>
    call(axios.get(`${ACK_API}/${language}/ack/practice?ackToken=${token(ackToken)}&mode=${encodeURIComponent(mode)}`))
        .then((response) => response.data);

// The answer is sent exactly as typed (no trim, no case change): the engine compares it as is.
export const checkPractice = (ackToken, language, practiceId, answer) =>
    call(axios.post(`${ACK_API}/${language}/ack/practice/check?ackToken=${token(ackToken)}`, { practiceId, answer }))
        .then((response) => response.data);

export const acknowledge = (ackToken) =>
    call(axios.put(`${ACK_API}/ack?ackToken=${token(ackToken)}`, null)).then(() => true);

const ackApi = { startAck, getPractice, checkPractice, acknowledge, normalizeError };

export default ackApi;
